import $ from 'jquery';

import './lib.scss';

window.jQuery = $;

$('document').ready(() => {});



// WEBPACK FOOTER //
// ./styleguide/src/assets/lib/lib.js